import React, { useRef } from 'react';
import { motion, useTransform } from 'framer-motion';
import { useSectionProgress } from './useSectionProgress';

const NOT = ['vídeo.', 'post.', 'site.', 'anúncio.'];

const Word = ({ progress, i, text }) => {
  const start = i * 0.15;
  const z = useTransform(progress, [start, start + 0.06, start + 0.1, start + 0.15], [-900, 0, 0, 320]);
  const opacity = useTransform(progress, [start, start + 0.04, start + 0.1, start + 0.14], [0, 1, 1, 0]);
  const rotX = useTransform(progress, [start, start + 0.06], [50, 0]);
  return (
    <motion.p style={{ z, opacity, rotateX: rotX }} className="absolute inset-0 flex items-center justify-center text-center">
      <span className="br-serif text-[13vw] sm:text-7xl lg:text-8xl font-semibold text-white/90 leading-tight">
        Não vendo <span className="block sm:inline line-through decoration-[#6B1D2F] decoration-4 text-white/40">{text}</span>
      </span>
    </motion.p>
  );
};

export const Manifesto3D = () => {
  const ref = useRef(null);
  const scrollYProgress = useSectionProgress(ref);
  const finalZ = useTransform(scrollYProgress, [0.62, 0.82], [-700, 0]);
  const finalOpacity = useTransform(scrollYProgress, [0.62, 0.78], [0, 1]);
  const ring = useTransform(scrollYProgress, [0, 1], [0, 180]);

  return (
    <section ref={ref} className="relative h-[420vh]" data-testid="manifesto-3d">
      <div className="sticky top-0 h-screen overflow-hidden br-perspective flex items-center justify-center">
        <motion.div style={{ rotate: ring }} className="absolute h-[70vmin] w-[70vmin] rounded-full border border-[#4ECDC4]/15" />
        <motion.div style={{ rotate: ring }} className="absolute h-[95vmin] w-[95vmin] rounded-full border border-dashed border-white/5" />
        <div className="relative h-full w-full br-preserve px-5">
          {NOT.map((t, i) => <Word key={t} progress={scrollYProgress} i={i} text={t} />)}
          <motion.div style={{ z: finalZ, opacity: finalOpacity }} className="absolute inset-0 flex flex-col items-center justify-center text-center px-5">
            <p className="br-mono text-[11px] text-[var(--br-teal)] mb-6">O que eu entrego</p>
            <h2 className="br-serif text-5xl sm:text-7xl lg:text-8xl font-semibold leading-[1.02] max-w-5xl">
              Entrego <span className="italic text-[var(--br-teal)]">valor percebido.</span>
            </h2>
            <p className="mt-8 max-w-xl text-base sm:text-lg text-[var(--br-muted)]">
              Vídeo, Instagram, site e anúncio são ferramentas. O que muda o seu negócio é a estratégia que faz todas elas contarem a mesma história.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
